import React from 'react';
import { Typography } from 'antd';
import '../styles/AutoSimulationPage.css';

const { Title, Paragraph } = Typography;

const simulationImages = [
    {
        id: 1,
        src: '/1.png',
        title: 'Automated Materials Design Workflow',
        description: 'This figure illustrates a multi-layered workflow for materials design, integrating LLM-assisted initial point search and CALPHAD-based candidate search. The process accelerates ideation, simulation, and experimental validation, balancing speed and reliability to efficiently identify high-quality material candidates.'
    },
    {
        id: 2,
        src: '/2.png',
        title: 'LLM-driven Alloy Screening Process',
        description: 'This figure details the step-by-step process of LLM-driven alloy screening, including feasibility assessment, handbook-guided selection, requirements verification, and component filtering. The workflow demonstrates how the system generates prompts, evaluates candidate alloys, and recommends optimal compositions based on user-defined property targets.'
    },
    {
        id: 3,
        src: '/3.png',
        title: 'Optimization Pathways for Alloy Performance',
        description: 'This figure presents optimization pathways for improving alloy performance, comparing traditional HEAs and titanium alloys. It visualizes the search space, optimization trajectory, and the resulting improvements in predicted yield strength and density, highlighting the effectiveness of the automated search strategy.'
    }
];

const AutoSimulationPage = ({ onNavigate }) => {
    return (
        <div className="auto-simulation-page">
            <div className="auto-simulation-container">
                <div className="auto-simulation-header">
                    <h2>Auto Simulation</h2>
                    <p className="auto-simulation-subtitle">Automated simulation workflows for intelligent alloy design and optimization</p>
                    <p className="auto-simulation-tagline">
                        From LLM-guided ideation to CALPHAD-based validation—automate simulation-driven materials discovery.
                    </p>
                    
                    {/* 添加跳转到数据分析的按钮 */}
                    <div className="simulation-nav-buttons" style={{ marginTop: '20px' }}>
                        <button 
                            className="simulation-nav-button"
                            onClick={() => onNavigate && onNavigate('Database', 'base', 7)} // 7是Simulation Data选项卡的索引
                            style={{
                                backgroundColor: '#52af77',
                                color: 'white',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '6px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                marginRight: '12px',
                                transition: 'background-color 0.3s'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#3d8b5f'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#52af77'}
                        >
                            📊 View Simulation Data Statistics
                        </button>
                        <span style={{ 
                            fontSize: '14px', 
                            color: '#666', 
                            fontStyle: 'italic' 
                        }}>
                            Explore statistical analysis of our generated simulation datasets
                        </span>
                    </div>
                </div>
                
                <div className="simulation-content">
                    {simulationImages.map(image => (
                        <div className="simulation-row" key={image.id}>
                            <div className="image-container">
                                <img
                                    alt={image.title}
                                    src={image.src}
                                    className="simulation-image"
                                />
                            </div>
                            <div className="simulation-caption">
                                <Title level={4}>{image.title}</Title>
                                <Paragraph>{image.description}</Paragraph>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="auto-simulation-help">
                    <h3>Understanding auto simulation workflows</h3>
                    <div className="help-content">
                        <div className="help-step">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h4>Workflow Overview</h4>
                                <p>Explore the multi-layered materials design workflow that combines AI-driven search with traditional simulation methods.</p>
                            </div>
                        </div>
                        <div className="help-step">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h4>Screening Process</h4>
                                <p>Learn how LLM-driven screening evaluates alloy candidates through systematic feasibility and requirements assessment.</p>
                            </div>
                        </div>
                        <div className="help-step">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h4>Optimization Results</h4>
                                <p>Analyze optimization pathways and performance improvements achieved through automated search strategies.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Feature Highlights - Compact */}
                <div className="feature-highlights-compact">
                    <h3>Feature Highlights</h3>
                    <div className="compact-features">
                        <div className="compact-feature-item">
                            <span className="compact-feature-icon">🧠</span>
                            <span className="compact-feature-text">Integrates LLMs for initial candidate generation from design prompts</span>
                        </div>
                        <div className="compact-feature-item">
                            <span className="compact-feature-icon">📚</span>
                            <span className="compact-feature-text">Combines handbook-guided filtering with user-defined requirements</span>
                        </div>
                        <div className="compact-feature-item">
                            <span className="compact-feature-icon">🔬</span>
                            <span className="compact-feature-text">CALPHAD used to verify and optimize performance predictions</span>
                        </div>
                        <div className="compact-feature-item">
                            <span className="compact-feature-icon">🔄</span>
                            <span className="compact-feature-text">Results fed back into the design loop for continuous improvement</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AutoSimulationPage; 
